import React from 'react';

// Prevents a runtime error in one page from blanking the whole published site.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Page error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6 py-24" data-testid="page-error-fallback">
          <h1 className="font-title text-2xl font-bold text-gobra-slate">Something went wrong</h1>
          <p className="text-muted-foreground mt-2 max-w-md">We hit a snag loading this page. Please try again.</p>
          <div className="flex gap-3 mt-6">
            <button onClick={() => window.location.reload()}
              className="bg-gobra-green hover:bg-gobra-green-dark text-white rounded-full px-6 py-2.5 text-sm font-medium">
              Reload page
            </button>
            <a href="/" className="border border-gobra-green text-gobra-green rounded-full px-6 py-2.5 text-sm font-medium">
              Go home
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
